import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { TransportService } from 'src/app/services/Transport/transport.service';

@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.css']
})
export class VehicleDetailsComponent implements OnInit {

  constructor(private transportService:TransportService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  VehicleDetailsModel = {
    VehicleID: 0,
    VehicleTypeID: 0,
    VehicleNumber: '',
    BusNo: 0,
    DriverName: '',
    CleanerName: '',
    CleanerPhoneNo: '',
    DriverPhoneNo: '',
    ModelNo: '',
    VehicleTypeName: "",
    InsuranceCompany: '',
    InsurancePremium:0,
    BusCapacity: 0,
    RouteID: 0,
    RouteName: '',
    IsActive: true,
    VendorID:0
}
Print  (item) {
    var url = "printstudentvehiclewise?VehicleID=" + item.VehicleID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}
msg = '';
Action = 'Add';
Submitted = false;
Clear  () {

    this.VehicleDetailsModel.VehicleID = 0;
    this.VehicleDetailsModel.VendorID = 0;
    this.VehicleDetailsModel.VehicleTypeID = 0,
    this.VehicleDetailsModel.VehicleNumber = '';       
    this.VehicleDetailsModel.BusNo = 0;
    this.VehicleDetailsModel.CleanerName = '';
    this.VehicleDetailsModel.CleanerPhoneNo = '';
    this.VehicleDetailsModel.DriverName = '';
    this.VehicleDetailsModel.DriverPhoneNo = '';
    this.VehicleDetailsModel.ModelNo = '';
    this.VehicleDetailsModel.VehicleTypeName = '';
    this.VehicleDetailsModel.InsuranceCompany = '';
    this.VehicleDetailsModel.InsurancePremium =0;
    this.VehicleDetailsModel.BusCapacity = 0;
    this.VehicleDetailsModel.RouteID = 0;
    this.msg = '';
    this.Action = 'Add';
    this.Submitted = false;
};

loading = true;
SaveVehicleDetails  (valid) {
    
    this.Submitted = true;
    if (valid && !this.ValidateDropdown()) {
        
        this.transportService.SaveVehicleDetails(JSON.stringify(this.VehicleDetailsModel)).subscribe( (response)=> {
       
       

        if (response.webResponse.Status)
            this.GetAllVehicleDetails();
        if (response.webResponse.Status && this.VehicleDetailsModel.VehicleID == 0)
            this.Clear();

        this.globalHelper.CheckActionStatus(response);
    });
}
};

 ValidateDropdown() {
    return this.VehicleDetailsModel.RouteID == 0 || this.VehicleDetailsModel.VehicleTypeID == 0 || this.VehicleDetailsModel.VendorID == 0
};

VehicleTypeList = [];
VehicleDetailsList:any;
GetAllVehicleDetails  () {
    this.spinnerService.show();
    this.transportService.GetAllVehicleDetails().subscribe( (response)=> {
        this.VehicleDetailsList = response.VehicleDetailsList;
        this.spinnerService.hide();
       
    });
};
   

Edit  (obj) {
    this.VehicleDetailsModel.VehicleID = obj.VehicleID;
    this.VehicleDetailsModel.VendorID = obj.VendorID.toString().trim();
    this.VehicleDetailsModel.VehicleTypeID = obj.VehicleTypeID;
    this.VehicleDetailsModel.VehicleNumber = obj.VehicleNumber;
    this.VehicleDetailsModel.BusNo = obj.BusNo;
    this.VehicleDetailsModel.CleanerPhoneNo = obj.CleanerPhoneNo;
    this.VehicleDetailsModel.DriverPhoneNo = obj.DriverPhoneNo;
    this.VehicleDetailsModel.BusCapacity = obj.BusCapacity;
    this.VehicleDetailsModel.RouteID = obj.RouteID;
    this.VehicleDetailsModel.ModelNo = obj.ModelNo;
    this.VehicleDetailsModel.InsuranceCompany = obj.InsuranceCompany;
    this.VehicleDetailsModel.InsurancePremium = obj.InsurancePremium;
    this.VehicleDetailsModel.IsActive = obj.IsActive;
    this.VehicleDetailsModel.CleanerName = obj.CleanerName;
    this.VehicleDetailsModel.DriverName = obj.DriverName;

};


VehicleMarkActive  (item) {
    this.Clear();
    this.VehicleDetailsModel.VehicleID = item.VehicleID;
    this.VehicleDetailsModel.IsActive = item.IsActive == true ? false : true;

    this.transportService.VehicleMarkActive(JSON.stringify(this.VehicleDetailsModel)).subscribe( (response)=> {
        this.GetAllVehicleDetails();
        this.Clear();
        this.globalHelper.CheckActionStatus(response);

    });
}


Route:any;
GetAllRoute  () {
    this.lookupService.GetLookupsList('RouteName', '').subscribe( (data)=> {
        this.Route = data.LookupItems;
    });
};
VehicleType:any;
GetAllVehicleType  () {
    this.lookupService.GetLookupsList('VehicleType', '').subscribe( (data)=> {
        this.VehicleType = data.LookupItems;

    });

};
VenderList:any;
GetVendor  () {
    this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
        this.VenderList = data.LookupItems;

    });
};


  ngOnInit() {
    this.GetAllRoute();
    this.GetAllVehicleType();       
    this.GetVendor();
    this.GetAllVehicleDetails();
  }

}
